// @ts-nocheck

import { isIOSEmbeddedAndStandalone } from '../client';
import { callNative, requestTypes } from '../lib/bridge';
import { type VibrationPattern } from '../types/device';

const vibrate = (duration: VibrationPattern | number | Array<number>) => {
  if (isIOSEmbeddedAndStandalone) {
    callNative(requestTypes.VIBRATE_DEVICE, {
      duration,
    });
  } else {
    const vibe =
      navigator?.notification?.vibrate ||
      navigator?.vibrate ||
      navigator?.webkitVibrate ||
      navigator?.mozVibrate ||
      navigator?.msVibrate;
    if (vibe) {
      vibe.call(navigator, duration);
    }
  }
};

export default {
  vibrate,
};
